module.exports = "https://img1.huilianyi.com/5/no-print-ja.5c7ecce638.appcore.png";